import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { messagesSchema } from 'Schemas/schemas';

import { getEntities } from './common';

export const getMessage = state => state.webChat.messages;
export const getMessageSearch = state => state.webChat.messageSearch;

export const getMessagesByIds = (entities, ids) => denormalize(ids, messagesSchema, entities);

const mergeIdsMessageByConsultId = (entities, messages, consult) => {
  const { consultId, groupId } = consult;
  const { bufferIds, bubbleMessages } = messages;
  const ids = bubbleMessages[groupId] || [];
  const idsByConsult = bufferIds[consultId];
  if (idsByConsult) {
    const newIds = [...new Set([...ids, ...idsByConsult])];
    return getMessagesByIds(entities, newIds);
  }
  return getMessagesByIds(entities, ids);
};

export const getMessages = createSelector(
  [getEntities, getMessage, (state, consultId, groupId) => ({ consultId, groupId })],
  mergeIdsMessageByConsultId,
);

export const getMessagesSearch = createSelector(
  [getEntities, getMessageSearch],
  getMessagesByIds,
);


const getMessageFromEntitiesByConsultGroup = (entities = {}, { conversationId, consultId }) => {
  const keys = Object.keys(entities);
  let item = {};
  const results = [];
  keys.forEach((key) => {
    item = entities[key];
    if (item.metadata.conversationId === conversationId) {
      results.push(item);
    } else if (consultId && !item.metadata.conversationId && item.metadata.consultId === consultId) {
      results.push(item);
    }
  });
  return results;
};

export const getMessageByConsultGroupId = createSelector(
  [state => state.entities.webChat.messages, (state, conversationId, consultId) => ({ conversationId, consultId })],
  getMessageFromEntitiesByConsultGroup,
);

const getLatestMessageByConsultGroupIdFromEntities = (entities = {}, conversationId) => {
  const keys = Object.keys(entities);
  let item = {};
  let result = entities[keys[0]];
  keys.forEach((key) => {
    item = entities[key];
    if (item.metadata.conversationId === conversationId && (item.sentAt > result.sentAt)) {
      result = item;
    }
  });

  return result;
};

const entitiesMessages = state => state.entities.webChat.messages;

export const getLatestMessageByGroupId = createSelector(
  entitiesMessages,
  entities => id => getLatestMessageByConsultGroupIdFromEntities(entities, id),
);


const getLatestMessageByConsultIdFromEntities = (entities = {}, consultId) => {
  const keys = Object.keys(entities);
  let item = {};
  let result = entities[keys[0]];
  keys.forEach((key) => {
    item = entities[key];
    if (item.metadata.consultId === consultId && (item.sentAt > result.sentAt)) {
      result = item;
    }
  });

  return result;
};

export const getLatestMessageByConsultId = createSelector(
  entitiesMessages,
  entities => id => getLatestMessageByConsultIdFromEntities(entities, id),
);


const getPrivateMessage = (entities = {}, conversationId) => {
  const keys = Object.keys(entities);
  let item = {};
  const results = [];
  keys.forEach((key) => {
    item = entities[key];
    if (item.metadata.conversationId === conversationId) {
      results.push(item);
    }
  });

  return results;
};

export const getMessageByPrivateConsult = createSelector(
  [entitiesMessages, (state, consultId) => consultId],
  getPrivateMessage,
);


const getMessagesByConsultId = (entities = {}, consultId) => {
  const keys = Object.keys(entities);
  let item = {};
  const results = [];
  keys.forEach((key) => {
    item = entities[key];
    if (item.metadata.consultId === consultId) {
      results.push(item);
    }
  });

  return results;
};

export const getMessageByConsult = createSelector(
  [entitiesMessages, (state, consultId) => consultId],
  getMessagesByConsultId,
);
